/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/css';
import { withBasicStyles, lightBlue, primaryBlue } from '@/styles/common';

export const useStyles = withBasicStyles(() => ({
  chatFooter: css`
    gap: 8px;
    position: relatative;
    z-index: 10;
    padding: 0 20px 10px 20px;
  `,

  footerTips: css`
    display: flex;
    align-items:center;
    justify-content: center;
    font-size: 12px;
    padding-bottom: 5px;
    color: rgba(0,0,0,0.4);
  `,

  popoverFooter: css`
    display: flex;
    gap: 8px;
    justify-content: end;
  `,

  sendButton: css`
    width: 23px !important;
    height: 23px !important;
    padding: 0 !important;
    min-width: 23px !important;
    min-height: 23px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000000;
    border: none;
    border-radius: 20px;
    color: white;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
    box-sizing: border-box;
    &:hover {
      background-color: #005ecb;
    }
    &:disabled {
      background-color: ${lightBlue};
      cursor: not-allowed;
    }
  `,

  uploadBtn: css`
    margin-left: 8px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${primaryBlue};
    color: white;
    font-weight: 700;
    font-size: 22px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    border: none;
    user-select: none;
    &:hover {
      background-color: #005ecb;
    }
  `,

  clearBtn: css`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid rgb(228, 231, 236);
    border-radius: 50%;
    width: 28px;
    height: 28px;
    box-sizing: border-box;
  `,

  stopButton: css`
    width: 23px !important;
    height: 23px !important;
    padding: 0 !important;
    min-width: 23px !important;
    min-height: 23px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  `,

  divider: css`
    width: 1px;
    height: 15px;
    margin-left: 3px;
    margin-right: 3px;
    background: #D0D5DD;
  `,

  sendWrapper: css`
    flex: 1;
    border-radius: 26px;
    .ant-attachment-list-card-type-preview {
      width: 52px;
      height: 52px;
    }
    .ant-attachment .ant-attachment-list-upload-btn {
      width: 52px;
      height: 52px;
      font-size: 24px;
    }
    .ant-attachment-list-card-type-overview {
      padding: 9px;
      line-height: 1;
    }
    .ant-attachment-list-card-type-overview .ant-attachment-list-card-icon {
      display: flex;
      padding-top: 0px;
    }
    .ant-attachment-list-card .ant-attachment-list-card-name {
      margin-bottom: 4px;
    }
    .ant-attachment-list-card-motion-leave-active {
      display: none;
    }
    .ant-progress-inner {
      width: 44px!important;
      height: 44px!important;
    }
    .ant-progress-text {
      font-size: 12px;
    }
  `,
}));
